"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomColor = exports.COLORS = void 0;
exports.COLORS = [
    '#0778B1',
    '#6E53A0',
    '#35499E',
    '#42BC99',
    '#31B44A',
    '#CF342A',
    '#E54D25',
    '#E5245D',
    '#C24398',
    '#22A3D6',
    '#51C5CF',
    '#A152A0',
    '#EF3A4A',
];
/**
 * Generates a random color from a series of preset options.
 */
var randomColor = function () {
    var randomIndex = Math.random() * (exports.COLORS.length - 1);
    var maxIndex = exports.COLORS.length - 1;
    var index = Math.round(Math.max(0, Math.min(randomIndex, maxIndex)));
    return exports.COLORS[index];
};
exports.randomColor = randomColor;
